class StepSignUp {
  constructor() {
    this._init();
  }

  _init() {
    document.addEventListener('DOMContentLoaded', () => {
      const professionnelCheckbox = document.getElementById(
        'professionnel_checkbox'
      ) as HTMLInputElement | null;
      const professionalFields = document.querySelector(
        '.professional-fields'
      ) as HTMLElement | null;
      const professionalInputs = document.querySelectorAll(
        '.professional-required'
      ) as NodeListOf<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >;

      if (professionnelCheckbox && professionalFields) {
        professionnelCheckbox.addEventListener('change', (event: Event) => {
          const isChecked = (event.target as HTMLInputElement).checked;

          if (isChecked) {
            professionalFields.style.display = 'grid';
            professionalInputs.forEach(input => {
              input.setAttribute('required', 'required');
            });
          } else {
            professionalFields.style.display = 'none';
            professionalInputs.forEach(input => {
              input.removeAttribute('required');
              input.value = '';
            });
          }
        });
      }
    });
  }
}

new StepSignUp();
